import { useUpdateEffect } from 'react-use';

import { usePaginationContext } from 'utils/contexts/pagination';
import { useSortingContext } from 'utils/contexts/sorting';

import { useEventHistoryQuery } from 'modules/userProfiles/hooks/useEventHistoryQuery';
import { EventHistoryQueryContext } from './EventHistoryQueryContext';
import { useEventHistoryFiltersContext } from './EventHistoryFiltersContext';
import { SORTABLE_TABLE_COLUMN_FIELD_MAPPING } from '../constants';
import { useCampaignLabels } from '../hooks/useCampaignLabels';

export const EventHistoryQueryContextProvider: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const { currentPage, pageSize, setCurrentPage } = usePaginationContext();
  const { eventTypeFilters, eventFilters, userAgentFilters, search } =
    useEventHistoryFiltersContext();
  const { sortBy, sortDirection } = useSortingContext();
  const { data, error, isLoading, isError } = useEventHistoryQuery({
    from: (currentPage - 1) * pageSize,
    limit: pageSize,
    filter: search,
    eventTypes: eventTypeFilters,
    sortBy: SORTABLE_TABLE_COLUMN_FIELD_MAPPING[sortBy],
    sortDirection,
    userAgents: userAgentFilters,
  });

  const campaignLabelsLookup = useCampaignLabels();

  useUpdateEffect(() => setCurrentPage(1), [userAgentFilters, eventFilters, search]);

  const userEvents = data?.jsonEvents || [];
  const totalUserEventCount = data?.count || 0;

  return (
    <EventHistoryQueryContext.Provider
      value={{
        campaignLabelsLookup,
        userEvents,
        errorMessage: error as string,
        isLoading,
        isError,
        totalUserEventCount,
      }}
    >
      {children}
    </EventHistoryQueryContext.Provider>
  );
};
